module.exports = __webpack_public_path__ + "static/media/v19.074de679.mp4";